import { useState } from "react";

const SUBMIT_ADDR = "https://readdy.ai/api/form/db7t0iomkl3spn8smcl0";
const topicOptions = ["内容纠错", "合作建议", "作品资料补充", "其他反馈"];

export default function FeedbackForm() {
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const payload = new FormData(form);

    const honeypot = String(payload.get("company_alt") ?? "").trim();
    if (honeypot) {
      setStatus("success");
      setFormError("");
      return;
    }
    payload.delete("company_alt");

    setStatus("idle");
    setFormError("");

    const body = new URLSearchParams();
    payload.forEach((value, key) => {
      body.append(key, String(value));
    });

    try {
      const response = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body,
      });
      const responseText = await response.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;

      const isSpam = typeof serverMsg === "string" && serverMsg.toLowerCase().includes("spam");

      if (response.ok && parsed?.code === "OK" && !isSpam) {
        setStatus("success");
        setFormError("");
        setMessage("");
        form.reset();
      } else {
        setStatus("error");
        setFormError(typeof serverMsg === "string" && serverMsg ? serverMsg : "提交失败，请稍后重试。");
      }
    } catch {
      setStatus("error");
      setFormError("网络异常，提交失败，请稍后重试。");
    }
  };

  return (
    <form data-readdy-form id="feedback-form" onSubmit={handleSubmit} className="bg-background-100/70 border border-background-200 rounded-lg p-5 md:p-7">
      <h3 className="font-heading text-lg font-bold text-foreground-950 mb-1">意见反馈</h3>
      <p className="text-xs text-foreground-500 mb-5">欢迎留下你的建议，帮助我们完善作品与资讯内容。</p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label htmlFor="fb-name" className="block text-sm font-label text-foreground-700 mb-1.5">称呼</label>
          <input
            id="fb-name"
            name="name"
            type="text"
            required
            placeholder="请输入你的称呼"
            className="w-full h-11 px-4 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-900 outline-none focus:border-primary-400 placeholder:text-foreground-400"
          />
        </div>
        <div>
          <label htmlFor="fb-email" className="block text-sm font-label text-foreground-700 mb-1.5">邮箱</label>
          <input
            id="fb-email"
            name="email"
            type="email"
            required
            placeholder="用于接收我们的回复"
            className="w-full h-11 px-4 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-900 outline-none focus:border-primary-400 placeholder:text-foreground-400"
          />
        </div>
      </div>

      <div className="mt-4">
        <label htmlFor="fb-topic" className="block text-sm font-label text-foreground-700 mb-1.5">反馈类型</label>
        <select
          id="fb-topic"
          name="topic"
          className="w-full h-11 px-4 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-800 outline-none focus:border-primary-400 cursor-pointer"
        >
          {topicOptions.map((t) => (
            <option key={t} value={t}>{t}</option>
          ))}
        </select>
      </div>

      <div className="mt-4">
        <label htmlFor="fb-message" className="block text-sm font-label text-foreground-700 mb-1.5">反馈内容</label>
        <textarea
          id="fb-message"
          name="message"
          required
          maxLength={500}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          rows={5}
          placeholder="请描述你的建议或问题（最多 500 字）"
          className="w-full px-4 py-3 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-900 outline-none focus:border-primary-400 resize-none placeholder:text-foreground-400"
        />
        <p className="mt-1 text-xs text-foreground-400 text-right">{message.length}/500</p>
      </div>

      <input
        type="text"
        name="company_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="form-contact-alt-field"
      />

      {status === "success" && (
        <div className="mt-4 flex items-center gap-2 text-sm text-primary-700 bg-primary-50 rounded-md px-4 py-3">
          <i className="ri-checkbox-circle-line" />
          提交成功，感谢你的反馈！
        </div>
      )}
      {status === "error" && (
        <div className="mt-4 flex items-center gap-2 text-sm text-accent-900 bg-accent-100 rounded-md px-4 py-3">
          <i className="ri-error-warning-line" />
          {formError}
        </div>
      )}

      <button
        type="submit"
        className="mt-5 inline-flex items-center gap-2 px-6 h-11 rounded-md bg-primary-500 text-background-50 text-sm font-label font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
      >
        <i className="ri-send-plane-line" />
        提交反馈
      </button>
    </form>
  );
}